const overlays = {
	state: {
		showBarcodeOverlay: false,
		barcodeMode: 'card',
	},
	mutations: {

	},
	actions: {
		openBarcodeOverlay(context, mode) {
			document.body.classList.add('camera-overlay');
			context.state.barcodeMode = mode || 'card';
			context.state.showBarcodeOverlay = true;
		},

		closeBarcodeOverlay(context) {
			document.body.classList.remove('camera-overlay');
			context.state.showBarcodeOverlay = false;
		},
	}
};

export default overlays;